import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

/** Renders children into the #bc-modal-root slot inside the phone shell. */
export default function ShellOverlay({ children, testid }) {
  const [root, setRoot] = useState(null);
  useEffect(() => {
    setRoot(document.getElementById("bc-modal-root"));
  }, []);
  if (!root) return null;
  return createPortal(
    <div
      data-testid={testid}
      className="absolute inset-0 pointer-events-auto"
    >
      {children}
    </div>,
    root
  );
}
